module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dark"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "side-nav side-nav-right center"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('router-link', {
    attrs: {
      "to": "/hangul-blocks"
    }
  }, [_vm._v("Hangul Blocks"), _c('br'), _vm._v("▼")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content--first split-bg clear"
  }, [_c('div', {
    staticClass: "column--single spacer--medium"
  }, [_c('div', {
    staticClass: "column--single"
  }, [_c('timeline')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer--medium center"
  }, [_c('router-link', {
    staticClass: "button caps",
    attrs: {
      "to": "/hangul-blocks"
    }
  }, [_vm._v("Next Chapter")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap clear"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "header-section-title caps rotate"
  }, [_vm._v("\n          The Basics\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('span', {
    staticClass: "header-section-number"
  }, [_vm._v("1–1")]), _vm._v(" "), _c('h1', [_vm._v("Origins of Type")]), _vm._v(" "), _c('p', {
    staticClass: "header-section-desc"
  }, [_vm._v("A history of lines to letters: The Hangul alphabet (Korean alphabet) and the Latin alphabet (English alphabet).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f354b92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/OriginsOfType.vue
// module id = 145
// module chunks = 0